import './tavarespavilion/style';
import FormStructure from './tavarespavilion/form_structure';

export default FormStructure;